import { usePermissions } from '../hooks/usePermissions';

interface RoleGateProps {
  children: React.ReactNode;
  allowedRoles: ('ADMIN' | 'ASOCIADO' | 'AFILIADO')[];
  permission?: string;
  resourceData?: any;
  fallbackComponent?: React.ReactNode;
  showFallback?: boolean;
}

export const RoleGate = ({ 
  children, 
  allowedRoles, 
  permission,
  resourceData,
  fallbackComponent,
  showFallback = false
}: RoleGateProps) => {
  const { user, checkPermission } = usePermissions();

  // Si no hay usuario, no mostrar nada a menos que se especifique fallback
  if (!user) {
    return showFallback && fallbackComponent ? <>{fallbackComponent}</> : null;
  }

  // Verificar roles básicos
  const hasRequiredRole = allowedRoles.includes(user.rol as 'ADMIN' | 'ASOCIADO' | 'AFILIADO');
  
  if (!hasRequiredRole) {
    return showFallback && fallbackComponent ? <>{fallbackComponent}</> : null;
  }

  // Verificar permisos específicos si se especifica una acción
  if (permission) {
    const permissionResult = checkPermission(permission, resourceData);
    if (!permissionResult.hasAccess) {
      return showFallback && fallbackComponent ? <>{fallbackComponent}</> : null;
    }
  }

  return <>{children}</>;
};

// Componente de conveniencia para mostrar contenido solo a admins
export const AdminOnly = ({ children }: { children: React.ReactNode }) => (
  <RoleGate allowedRoles={['ADMIN']}>
    {children}
  </RoleGate>
);

// Componente de conveniencia para mostrar contenido a admins y asociados
export const AdminAndAssociate = ({ children }: { children: React.ReactNode }) => (
  <RoleGate allowedRoles={['ADMIN', 'ASOCIADO']}>
    {children}
  </RoleGate>
);

// Componente de conveniencia para mostrar contenido a todos los roles autenticados
export const AuthenticatedOnly = ({ children }: { children: React.ReactNode }) => (
  <RoleGate allowedRoles={['ADMIN', 'ASOCIADO', 'AFILIADO']}>
    {children}
  </RoleGate>
);